/**
 * Constants for AdminMintingDapps container
 */

export const STORAGE_KEY = 'viribright_minting_dapps_backup';
export const REGISTRY_SYNC_KEY = 'viribright_minting_dapps_synced';
